'use strict';

var storage = require('./storage');

module.exports = {
    isFirstTimeUser: function isFirstTimeUser() {
        return storage.global.get('user').loginMethod ? false : true;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/UserHelpers.js
// module id = 864
// module chunks = 0